export enum DiagnosticTroubleCodeCategory {
    Default,
    Ibox,
    Carrier
}

export interface IReeferTroubleCodeHistory {
    Id: number;
    VehicleId: number;
    FirstSeenTime: Date;
    LastSeenTime: Date;
    ClearedTime?: Date;
    DiagnosticTroubleCodeId: number;
    Category: DiagnosticTroubleCodeCategory;
    CreatedTime: Date;
    UpdatedTime: Date;
}
